/* eslint-disable camelcase */
import { channelsMetadata, chatActiveTab, ClientChatTypes, getTypeOfUser, HelpTypesClientChat, TypeOfUser } from '@pharmaplan/common';
import { useAppSelector } from '../useAppSelector';

const { users, support, pharmacy } = ClientChatTypes;
const useChatSeparation = (url: string) => {
  const loggedInUser = useAppSelector(getTypeOfUser);
  const channelData = useAppSelector(channelsMetadata);
  const active = useAppSelector(chatActiveTab);

  const metadata = channelData?.[url] ?? {};
  const { user_type } = metadata ?? {};

  const splitType = `${user_type}`?.split?.(',');
  const isDoubleUser = splitType?.length === 2;
  const isSingleUser = splitType?.length === 1;

  const selectedSegmentAdmin = (() => {
    let showSegment = false;
    if (isDoubleUser) {
      showSegment = active === users;
    } else {
      showSegment = active
        === HelpTypesClientChat[splitType?.[0] as keyof typeof HelpTypesClientChat];
    }
    return showSegment;
  })();

  const selectedSegmentPharmacist = (() => {
    let showSegment = false;
    if (isSingleUser) {
      showSegment = active === support;
    } else {
      showSegment = active === pharmacy;
    }
    return showSegment;
  })();

  const selectedSegmentPharmacy = (() => {
    let showSegment = false;
    if (isSingleUser) {
      showSegment = active === support;
    } else {
      showSegment = active === HelpTypesClientChat[splitType?.[1] as keyof typeof HelpTypesClientChat];
    }
    return showSegment;
  })();

  const segmentConfig = {
    [TypeOfUser.pharmacist]: selectedSegmentPharmacist,
    [TypeOfUser.technician]: selectedSegmentPharmacist,
    [TypeOfUser.student]: selectedSegmentPharmacist,
    [TypeOfUser.pharmacy]: selectedSegmentPharmacy,
    [TypeOfUser.admin]: selectedSegmentAdmin,
    [TypeOfUser.superAdmin]: selectedSegmentAdmin,
  };

  return { selectedSegment: segmentConfig[loggedInUser as keyof typeof segmentConfig], userType: user_type };
};

export default useChatSeparation;
